export default __webpack_public_path__ + "static/media/shop.5db75188.svg";